export default __webpack_public_path__ + "static/media/product-small.eed0ef8e.jpg";